import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable()
export class PrintService {

  public printHtml(title: string, html: string, style?: string, includePageStyles?: boolean) {
    let css = '';
    if (includePageStyles) {
      css += this.getAllStyles();
    }
    if (style) {
      css += style;
    }

    // console.log('Print contents:', printContents, printContents.length);
    var onLoad = "window.print(); ";
    if (environment.production)
      onLoad = onLoad + "window.close()";

    const popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
        <html>
            <head>
            <title>${title || 'Print'}</title>
            <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">
            ${css}
            </head>
            <body onload="${onLoad}">${html}</body>
        </html>`,
    );

    popupWin.document.close();
  }

  public getAllStyles(): string {
    const styles = document.getElementsByTagName('style');
    let style = '';
    let i = 0;
    for (i = 0; i < styles.length; i++) {
      style = style + `<style>${styles[i].innerHTML}</style>`;
    }
    return style;
  }
}
